import { Controller } from "@hotwired/stimulus";
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';


export default class extends Controller {
  static targets = ["tab"];
  connect() {
    $('.nav-tabs a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
      const tabId = e.target.getAttribute('href');
      if (tabId === '#calendar') {
        this.load_calendar();
      }
    })
    this.load_calendar();
  }

  load_calendar(){
    const windowWidth = window.innerWidth;
    const defaultView = (windowWidth < 1000) ? 'timeGridDay' : 'timeGridWeek';
    const calendarEl = document.querySelector('.uaba-calendar');
    const residentData = calendarEl.dataset.resident;
    const organizationData = calendarEl.dataset.organization;

    const loader = (isLoading, view) => {
      const loaderElement = document.querySelector('.fas.fa-circle-notch.fa-spin')
      if (isLoading) {
        loaderElement.style.display = 'block';
      } else {
        loaderElement.style.display = 'none';
      }
    }

    const calendarOptions = {
      plugins: [dayGridPlugin, timeGridPlugin],
      firstDay: 1,
      events: residentData
        ? `/organizations/${organizationData}/residents/${residentData}/drug_tests.json`
        : `/organizations/${organizationData}/drug_tests.json`,
      loading: loader,
      height: 800,
      headerToolbar: {
        right: 'dayGridMonth,timeGridWeek,timeGridDay,prev,today,next'
      },
      initialView: defaultView,
      nowIndicator: true
    };

    const calendar = new Calendar(calendarEl, calendarOptions);
    calendar.render();
  }
}
